/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePackageSchema
 */
export interface CreatePackageSchema {
    /**
     * 
     * @type {string}
     * @memberof CreatePackageSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageSchema
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageSchema
     */
    source: CreatePackageSchemaSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageSchema
     */
    condaName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageSchema
     */
    clientVersion?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePackageSchema
     */
    include: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageSchema
     */
    channel?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePackageSchema
     */
    file?: number;
}


/**
 * @export
 */
export const CreatePackageSchemaSourceEnum = {
    Pip: 'pip',
    Conda: 'conda'
} as const;
export type CreatePackageSchemaSourceEnum = typeof CreatePackageSchemaSourceEnum[keyof typeof CreatePackageSchemaSourceEnum];


/**
 * Check if a given object implements the CreatePackageSchema interface.
 */
export function instanceOfCreatePackageSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "specifier" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "include" in value;

    return isInstance;
}

export function CreatePackageSchemaFromJSON(json: any): CreatePackageSchema {
    return CreatePackageSchemaFromJSONTyped(json, false);
}

export function CreatePackageSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePackageSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'specifier': json['specifier'],
        'source': json['source'],
        'condaName': !exists(json, 'conda_name') ? undefined : json['conda_name'],
        'clientVersion': !exists(json, 'client_version') ? undefined : json['client_version'],
        'include': json['include'],
        'channel': !exists(json, 'channel') ? undefined : json['channel'],
        'file': !exists(json, 'file') ? undefined : json['file'],
    };
}

export function CreatePackageSchemaToJSON(value?: CreatePackageSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'specifier': value.specifier,
        'source': value.source,
        'conda_name': value.condaName,
        'client_version': value.clientVersion,
        'include': value.include,
        'channel': value.channel,
        'file': value.file,
    };
}

